import { useEffect, useRef } from "react";
import { AdvancedMarker, Map, useMap } from "@vis.gl/react-google-maps";

const MapViewport = ({ points, fitNonce }) => {
  const map = useMap();
  const lastFitNonce = useRef(-1);
  useEffect(() => {
    if (!map || !points.length || !window.google) return;
    if (lastFitNonce.current === fitNonce) return;
    const bounds = new window.google.maps.LatLngBounds();
    points.forEach(({ position }) => bounds.extend(position));
    if (points.length === 1) { map.setCenter(points[0].position); map.setZoom(8); }
    else map.fitBounds(bounds, 64);
    lastFitNonce.current = fitNonce;
  }, [map, points, fitNonce]);
  return null;
};

export const OperationsMap = ({ points, selectedKey, onSelect, fitNonce }) => (
  <Map
    mapId={process.env.REACT_APP_GOOGLE_MAP_ID}
    defaultCenter={{ lat: 20, lng: 0 }}
    defaultZoom={2}
    minZoom={2}
    gestureHandling="greedy"
    disableDefaultUI
    zoomControl
    clickableIcons={false}
    reuseMaps
    data-testid="operations-google-map"
  >
    <MapViewport points={points} fitNonce={fitNonce} />
    {points.map((point) => {
      return (
        <AdvancedMarker key={point.key} position={point.position} zIndex={point.category === "live" ? 30 : 10} onClick={() => onSelect(point)} title={`Open ${point.name} location details`}>
          <span
            className={`map-pin-button ${selectedKey === point.key ? "selected" : ""} ${point.category}`}
            data-testid={`map-marker-${point.key}`}
          >
            <span className="map-marker-core"><i /></span>
          </span>
        </AdvancedMarker>
      );
    })}
  </Map>
);